/** ConfidenceLabel — the canonical data-source chip used across the
 *  Fortune-500 UI. F-115 wire-up: fetches the label + tone from the single
 *  source of truth (`@/lib/labels`) so any future rename or copy change
 *  flows through automatically. `SOURCE_COLORS` is kept only for legacy
 *  callers that pass raw hex colours (none in production today). */
import { labelFor, TONE_COLORS } from "@/lib/labels";
import { SOURCE_COLORS } from "@/lib/theme";

export function ConfidenceLabel({ source = "MODEL", size = "sm" }) {
  const row = labelFor(source);
  // Prefer tone-mapped colour (WCAG-checked); fall back to legacy palette.
  const bg = TONE_COLORS[row.tone] || SOURCE_COLORS[source] || SOURCE_COLORS.MODEL;
  const fs = size === "xs" ? 8 : 9;
  const label = row.label;
  return (
    <span
      data-testid={`confidence-${label.toLowerCase()}`}
      title={row.helper}
      aria-label={`${label} — ${row.helper}`}
      style={{
        display: "inline-block",
        padding: "1px 6px",
        borderRadius: 3,
        background: bg,
        color: "#fff",
        fontSize: fs,
        fontWeight: 800,
        letterSpacing: "0.07em",
        fontFamily: "monospace",
        marginLeft: 4,
        cursor: "help",
        verticalAlign: "middle",
      }}
    >
      {label}
    </span>
  );
}
